module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAMAAADeH4ToAAAAV1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////+ORg7oAAAAHHRSTlMA9O8ifWFOEs2toXZsRTswBtvDs5aJVBjigGZb5s2LDAAAAIVJREFUGNNtzzcWxCAUQ1ERDM45TND+1znGNB4dv/IWiI97Q91BepNqgbSjWEnuQo5s7m+HLiJ6h6EI8ZKxImm3iGMhadpEE3OWuRWo+Z8JcJR6oBBaAGxiaaISK6AT+d9erDxtp/QBDmrfNKIB/YNhFvKAXvc6Sc9zuGqssbNv19KYqQd+1TwdzeznSwcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-ios-active.png
// module id = KZ1d
// module chunks = 0 1